const TwitterRoundIcon = ({ color }: any) => {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="17" cy="17" r="16" fill="#1DA1F2" stroke="white" stroke-width="2"/>
    <path d="M23.9997 11.0008C23.3613 11.4512 22.6544 11.7956 21.9063 12.0208C21.5048 11.5592 20.9712 11.232 20.3777 11.0835C19.7842 10.935 19.1593 10.9723 18.5877 11.1905C18.0161 11.4087 17.5253 11.7971 17.1817 12.3033C16.838 12.8095 16.6581 13.4091 16.6663 14.0208V14.6875C15.4948 14.7179 14.3339 14.4581 13.287 13.9311C12.2402 13.4042 11.3379 12.4135 10.6644 11.4544C10.6644 11.4544 7.99967 17.6675 13.9997 20.3342C12.6267 21.2662 10.9911 21.7335 9.33301 21.6675C15.333 25.0008 22.6663 21.6675 22.6663 14.0008C22.6657 13.8151 22.6479 13.6299 22.613 13.4475C23.2934 12.7765 23.7736 11.9293 23.9997 11.0008Z" fill="white"/>
    </svg>
    
  )
}

export default TwitterRoundIcon
